import workOrderType from "./work-order-type";
import datetime from "./datetime";
import date from "./date";
import dayIntervalTime from "./day-interval-time";
import enumText from "./enum-text";
import currency from "@/filters/currency";
import stripHtml from "@/filters/strip-html";
import datetimeHoursMinutes from "@/filters/datetime-hours-minutes";
import expireTime from "@/filters/expireTime";
import verifyResultMessage from "@/filters/verifyResultMessage";

export default {
    install(Vue) {
        Vue.filter('workOrderType', workOrderType);
        Vue.filter('datetime', datetime);
        Vue.filter('datetimeHoursMinutes', datetimeHoursMinutes);
        Vue.filter('date', date);
        Vue.filter('dayIntervalTime', dayIntervalTime);
        Vue.filter('enumText', enumText);
        Vue.filter('currency', currency);
        Vue.filter('stripHtml', stripHtml);
        Vue.filter('expireTime', expireTime);
        Vue.filter('verifyResultMessage', verifyResultMessage);
    }
}
